import {
  AwsIntegration,
  AzureIntegration,
  StackAwsIntegrationAttachment,
  StackAzureIntegrationAttachment,
  StackIntegrationGcp,
} from "types/generated";

export enum CLOUD_INTEGRATIONS {
  AWS = "AWS",
  Azure = "Azure",
  GCP = "GCP",
}

export type CloudIntegrationAttachment =
  | StackAwsIntegrationAttachment
  | StackAzureIntegrationAttachment
  | StackIntegrationGcp;

export type GetAttachableCloudIntegrationsGql = {
  attachableAzureIntegrationsInSpace: AzureIntegration[];
  attachableAwsIntegrationsInSpace: AwsIntegration[];
};
